(function(angular){
	'use strict';

	angular
		.module('authModule')
		.controller('LoginController', [
			'$scope',
			'$window',
			'globalConfig',
			'urlFactory',
			LoginControllerFunction
		]);

	function LoginControllerFunction(
		$scope,
		$window,
		globalConfig,
		urlFactory
	){
		var login = this;

		login.checkCaptcha = function() {
			if(angular.isDefined(globalConfig.captchaMeta)) {
				globalConfig.captchaMeta.grecaptcha.execute(globalConfig.captchaMeta.v3Key, {action: 'login'}).then(function(token) {
					$window.document.getElementById('reCaptcha3Answer').value = token;
					urlFactory.submitFormById('loginForm');
				});
			} else {
				urlFactory.submitFormById('loginForm');
			}
		};

		login.$onInit = function() {
			angular.extend(login, globalConfig);

			if(urlFactory.getUrlParamAsBool('loginFailed')) {
				$scope.$watch('login.loginForm.username', function(loginForm) {
					if(angular.isDefined(loginForm)) {
						var loginErrorObject = {};

						if(login.rememberEmail){
							loginErrorObject = {
								password: 'Password is incorrect'
							};
						} else {
							loginErrorObject = {
								username: 'Username and/or password is incorrect',
								password: 'Username and/or password is incorrect'
							};
						}

						urlFactory.handleServerValidation(login.loginForm, urlFactory.spoofApiError(loginErrorObject));
					}
				});
			}
			login.attempts = urlFactory.getUrlParamAsNumber('attemptsLeft');
		};
	}
})(window.angular);